<template>
  <div>
    <div class="header">
      <h1>Edit Profile</h1>
    </div>
    <ValidationObserver v-slot="{ invalid, validated, passes }">
      <div class="user-form outline">
        <v-layout wrap>
          <v-flex md6>
            <ValidationProvider
              v-slot="{ errors  }"
              rules="required|min:2"
            >
              <v-text-field v-model="formData.firstname" :error-messages="errors" label="First Name"/>
            </ValidationProvider>
          </v-flex>
          <v-flex md6>
            <ValidationProvider
              v-slot="{ errors }"
              name="lastname"
              rules="required"
            >
              <v-text-field v-model="formData.lastname" :error-messages="errors" label="Surname"/>
            </ValidationProvider>
          </v-flex>
          <v-flex md6>
            <ValidationProvider
              v-slot="{ errors }"
              name="telephone"
              rules="numeric"
            >
              <v-text-field v-model="formData.telephone" :error-messages="errors" label="Telephone"/>
            </ValidationProvider>
          </v-flex>
          <v-flex md6>
            <ValidationProvider
              v-slot="{ errors }"
              name="mobile"
              rules="max:20"
            >
              <v-text-field v-model="formData.mobile" :error-messages="errors" label="Mobile"/>
            </ValidationProvider>
          </v-flex>
          <!-- <v-flex md6>
            <v-file-input
              v-model="formData.avatarImage"
              accept="image/png, image/jpeg, image/bmp"
              placeholder="Profile Image"
              prepend-icon="mdi-camera"
              label="Profile Image"
            ></v-file-input>
          </v-flex> -->
          <v-flex 
            v-if="!submitted" 
            md12>
            <v-btn
              class="submit-btn" 
              :disabled="invalid"
              @click.prevent="passes(updateUser)">Submit</v-btn>
          </v-flex>
          <v-flex 
            v-if="submitted && !loading" 
            md12>
            <span class="green--text on-success">Thank you, {{ user.Profile.firstName }}. Profile updated successfully!</span>
          </v-flex>
          <v-flex
            v-if="submitted && loading">
            <span class="red--text">Updating ...</span>
          </v-flex>
        </v-layout>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>

import { ValidationObserver, ValidationProvider } from "vee-validate";
import { UpdateUserInOrg } from "@/services/API.js";
import { AmplifyEventBus } from "aws-amplify-vue";

export default {
  name: 'UserForm',
  components: {
    ValidationObserver,
    ValidationProvider
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      formData: {
        firstname: '',
        lastname: '',
        telephone: '',
        mobile: '',
        avatarImage: null
      },
      submitted: false,
      loading: false
    }
  },
  watch: {
    user (val) {
      if(val.Profile) {
        this.formData.firstname = val.Profile.firstName;
        this.formData.lastname = val.Profile.lastName;
        this.formData.telephone = val.Profile.telephone;
        this.formData.mobile = val.Profile.mobile;
      }
    }
  },
  methods: {
    async updateUser() {
      this.submitted = true;
      this.loading = true;
      const res = await UpdateUserInOrg(
        this.user.Org.id,
        this.user.email,
        {
          firstName: this.formData.firstname,
          lastName: this.formData.lastname,
          telephone: this.formData.telephone,
          mobile: this.formData.mobile
        }
      )
      
      if (res && res.email) {
        AmplifyEventBus.$emit("snackEvent", {color: "green", text: "Your profile has been updated"})
        this.$emit('userUpdated')
        this.loading = false;

        setTimeout(() => {
          this.submitted = false
        }, 5000)
      } else {
        AmplifyEventBus.$emit("snackEvent", {color: "green", text: "Something has gone wrong"})
      }
    },
    initialiseForm() {
      this.formData.firstname = '';
      this.formData.lastname = '';
      this.formData.telephone = '';
      this.formData.mobile = '';
    }
  }
}
</script>

<style lang="scss">
  .header {
    h1 {
      font-size: 24px !important;
      text-transform: uppercase;
    }
  }
  .submit-btn {
    background-color: #24AB80 !important;
    color: white !important;
  }
  .on-success {
    font-size: 20px;
  }
</style>